export enum ClearingDataDataTypeEnum {
  ARRAY = 'ARRAY',
  ARRAY_INDEX = 'ARRAY_INDEX',
  STRING = 'STRING',
  DATE = 'DATE',
  DATETIME= 'DATETIME',
  OBJECT = 'OBJECT'
}
